module.exports = __webpack_public_path__ + "img/always-fun-games.7434b965.jpg";